<template>
    <div>
        <div id="container">
			<div id="content">
				<h1>2019广州车展、哈弗H6 GT版、H9罗伦士极星版正式开启预售</h1>
				<p class="clearfix"><a href="https://mbd.baidu.com/newspage/data/landingsuper?context=%7B%22nid%22%3A%22news_10287903883259553587%22%7D&n_type=0&p_from=1" style="float:left;">查看原文</a><a style="float:right;" href="http://web.qvkandian.cn/qvkdcn/">查看更多</a></p>
				<p style="">文章来源网络，侵删。</p>
				<p>蓝鲸汽车11月22日讯，在今日开幕的广州车展上，长城全新哈弗H6 GT版正式开启预售，此次新车共推出3款车型，预售价为13万元-14.1万元;与此同时，哈弗H9罗伦士极星版也同步开启预售，预售价格为36.88万元。</p>
				<img src="../../static/img/car1.jpg" alt="">
				<p>全新哈弗H6 GT版基于哈弗H6车型而打造，外观方面，新车与现款哈弗H6的车身设计保持一致，配置方面，全新哈弗H6 GT 劲擎版新增了米其林轮胎、前排座椅加热、主驾驶座椅8向电动可调、副驾驶座椅4向电动可调、8扬声器共计6项配置。

动力方面，新车搭载2.0T+7速湿式双离合变速箱的动力组合，发动机最大功率为224马力(165kW)，峰值扭矩为385牛·米，百公里加速达7.6s。据了解，车展期间订车可享包括现金礼、金融礼、置换礼、智享礼、转介礼以及订车礼在内的六项优惠。

哈弗H6作为“国民神车”，累计77个月稳居国内SUV市场销量榜首。最新数据显示，哈弗H6依旧表现抢眼，1-10月累计销量达30万辆，其中10月销售40623辆，环比增长28.10%。

</p>
				<img src="../../static/img/car2.jpg" alt="">
				<p>与此同时，哈弗H9罗伦士极星版也同步开启预售。据介绍，新车是基于哈弗H9车型，由德国商罗伦士改装而来。外观方面，新车红灰搭配的车身配色运动感十足。配置方面，新车换装了大尺寸全地形越野轮胎，同时悬架系统升高2-3英寸。据了解，订车即可享受现金礼、质保礼、流量礼三重大礼。</p>
				<img src="../../static/img/car3.jpg" alt="">
				<p>此外，长城哈弗F系—2020款哈弗F7、哈弗F7x性能版、2020款哈弗F5三款车型也一同亮相本次车展。据悉，哈弗F系平均月销过万，累积用户突破18万。(蓝鲸汽车 万雪飞)</p>
				
			</div>
			<div id="divnode15743"></div>
		</div>
    </div>
</template>
<script>
export default {
    name:'Contdetailpage',
    methods:{
        checkload:function (){
            // console.log(document.referrer);
			
			// if(document.referrer == ''){
			if(document.referrer != 'http://web.qvwen.cn/qvwcn/Contnews'){
				$("#content").css("display","block");
			}else{
				$("#content").css("display","none");
				var insertPoint = document.getElementById('divnode15743');
				var iframe = document.createElement('iframe');
				var div_node = document.createElement('div');
				div_node.id = "div_node";
				iframe.allowTransparency = "true";
				iframe.setAttribute('src', 'http://m.qvkandian.com/page/Contforpage.html');
				// iframe.setAttribute('src', 'http://m.qvkandian.com:8020/sg/Contforpage.html');
				iframe.width = '100%';
				iframe.height = '250px';
				iframe.setAttribute('frameborder', 0);
				iframe.id = "zl-cprzy312";
				iframe.scrolling = "no";
				iframe.style.display = 'block';
				iframe.referrerpolicy = 'no-referrer';
				div_node.appendChild(iframe);
				insertPoint.appendChild(div_node);
			}
        }
    },
    mounted:function(){
        this.checkload();
    }
}
</script>
<style scoped>
#content{
	width: 800px;
	margin: 0 auto;
	line-height: 40px;
}
#content a{
	text-decoration: none;
	color: #aaa;
}
#content img{
	width: 94%;
	margin: 10px;
}
.clearfix:after{
	display: block;
	content:'';
	clear: both;
}
</style>


// WEBPACK FOOTER //
// src/viewsource/Contdetailpage.vue